/* vim: set expandtab sw=2 ts=2 sts=2: */
import React from 'react';
import FilterableTable from './FilterableTable';
import {
  Header,
  Footer
} from '../containers';

export default class Solutions extends React.Component {
  render() {
    return (
      <div>
        <Header/>
        <div className="container">
        <FilterableTable />
        </div>
        <Footer/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Solutions.js